import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from "@angular/router";
import {Observable, filter, first} from "rxjs";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {HostingService} from "../hosting.service";
import {HostingDomainsZoneDataMapper} from "../domains/hosting-domains-zone-mapper";
import {clientRoles} from "../../../../user/user-roles-actions";

@Injectable()
export class HostingDomainsManageAllResolver implements Resolve<null> {

  constructor(
    private _router: Router,
    private _hostingService: HostingService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const currentWorkspaceRoleId: any = +localStorage.getItem('dbCurrentWorkspaceRoleId');
      if ([clientRoles.SITE_DEV].includes(currentWorkspaceRoleId)) {
        this._router.navigate(['/websites']);
        reject();
      }
      else {
        this._hostingService.getZones()
          .pipe(filter((response: DbResponse): boolean => !!response),
          first())
          .subscribe((response) => {
            if (response.success) {
              resolve(response.data.map( (zone) => HostingDomainsZoneDataMapper.map(zone)));
            }
            else {
              resolve(null);
            }
          });
      }
    });
  }

}
